export default __webpack_public_path__ + "static/media/earn-shape-right.77608903.png";